export default {"src":"/_next/static/media/palau.dcc64471.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};